import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import { IUserTextStyleProps } from "./interfaces";

export const StyledUser = styled(Link)`
    display: flex;
    align-items: center;
    &.Disabled {
        pointer-events: none;
    }
    &.Reversed {
        flex-direction: row-reverse;
        justify-content: flex-end;
    }
`;

export const Username = styled.div`
    margin-right: 6px;
    font-style: italic;
    color: ${p => p.theme.c.boost};
    font-variant: normal;
    font-size: 16px;

    &.Huge {
        font-size: 23px;
        font-weight: 400;

        ${p =>
        p.theme.xs(css`
                font-size: 20px;
            `)}
    }
`;

const $userDimension = 30;
export const UserImage = styled.div`
    border-radius: ${$userDimension / 2}px;
    overflow: hidden;
    width: ${$userDimension}px;
    height: ${$userDimension}px;
    margin-right: 14px;
    box-sizing: border-box;
    border: 1px solid ${p => p.theme.c.boost};
    flex-shrink: 0;

    img {
        width: ${$userDimension - 2}px;
        height: ${$userDimension - 2}px;
    }

    .i-user {
        font-size: 42px;
        margin-top: -7px;
        margin-left: -7px;
        display: block;
        color: ${p => p.theme.c.active};
    }

    &.Huge {
        width: 50px;
        height: 50px;
        border: 2px solid ${p => p.theme.c.boost};
        border-radius: 25px;
        img {
            width: 46px;
            height: 46px;
        }

        .i-user {
            margin-top: -11px;
            margin-left: -11px;
            font-size: 68px;
        }
    }
`;

export const UserText = styled.div<IUserTextStyleProps>`
    line-height: 1.1;
    text-align: ${p => p.reversed ? "left" : "right"};
`;

export const Time = styled.div`
    color: ${p => p.theme.c.disabled};
    text-align: right;
    font-size: 18px;
    font-weight: 300;
    ${p =>
        p.theme.xs(css`
            font-size: 16px;
        `)}
`;
